import { EventEmitter } from 'events'

export class CustomEventEmitter<T extends string> extends EventEmitter {
  emitEvent(event: T, payload?: any): void {
    this.emit(event, payload)
  }
}
